export const LOAD_NEW_STATE = 'LOAD_NEW_STATE';

export const loadNewState = state => ({
  type: LOAD_NEW_STATE,
  state,
});
